import React, { useState } from 'react';
import { useDispatch, useSelector} from 'react-redux';
import { useTranslation } from "react-i18next";
import { RootState } from "@/store";
import { data_create_api_resource } from '@/utils/http_functions';
import ErrorMessage from '@/components/ErrorMessage';

import {
  FormControlLabel, Radio, RadioGroup,
  FormControl, Typography, Stack, Button
} from '@mui/material';


import { 
  editContract,
  setInvoiceOnline
} from '@/actions/contracts';

import { default as invoiceOnlineService } from "../../services/changeInvoiceOnlineDialog";
import { IUpdateInvoiceOnline } from '../../types/changeInvoiceOnlineDialog';

export const ChangeInvoiceOnline = () => {

  const dispatch = useDispatch();
  const token = useSelector((store: RootState) => store.auth.token);
  const contract = useSelector((store: RootState) => store.contracts.view_contract);
  const { t } = useTranslation();
  
  const [ sendMethod, setSendMethod ] = useState(contract.invoice_online);
  const [ actualitzar, setActualitzar ] = useState(false)
  const [ error, setError ] = useState(false)
  
  const handleChangeTypeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSendMethod((event.target as HTMLInputElement).value);
    setActualitzar(!actualitzar);
  };
  const handleClickClose = () => {
    dispatch(editContract(false));
  };
  const handleClickUpdate = async () => {
    setError(false);
    const dades: IUpdateInvoiceOnline = {
      token: token,
      contractName: contract.name,
      sendMethod: sendMethod
    }

    try {
      invoiceOnlineService
        .updateInvoiceOnline(dades)
        .then((data) => {
          dispatch(setInvoiceOnline(sendMethod));
        }).catch((error) => {
          setError(true);
        }).finally(() => {
          if(!error){
            dispatch(editContract(false))
          }
        })
    } catch {
      setError(true);
    }
  };

  return (
    <div>
      {error ?
        <div>
          <Typography 
            id="dialog-title" 
            variant="h5"
            style={{padding: 12}}
          >
            {t('common:text.invoice_online_dialog_title')}
          </Typography>

          <ErrorMessage/>

          <Button
            style={{paddingTop: 12, paddingLeft: 12}}
            variant={'text'}
            color={'primary'}
            onClick={handleClickClose}
          >
            {t('common:text.invoice_online_btn_close')}
          </Button>
        </div>
        
        :
        <Stack>
          <Typography 
            id="dialog-title" 
            variant="h5"
            style={{padding: 12}}
          >
            {t('common:text.invoice_online_dialog_title')}
          </Typography>
    
          <div
            id="div-info"
            style={{padding: 12}}
          >
            {sendMethod === 'email' ?
              <div>{ t('common:text.invoice_online_info_email') }</div> : 
              <div>{ t('common:text.invoice_online_info_postal') }</div>
            }
          </div>
          
          <FormControl 
            id="dialog-form-control"
            style={{padding: 12}}
          >
            <RadioGroup
              id="radio-buttons-group"
              defaultValue={sendMethod}
              value={sendMethod}
              onChange={handleChangeTypeEmail}
            >
              <FormControlLabel id="email_option" value={'email'} control={<Radio />} label={t('common:text.invoice_online_email')} />
              <FormControlLabel id="postal_option" value={'postal'} control={<Radio />} label={t('common:text.invoice_online_postal')} />
            </RadioGroup>
          </FormControl>
    
          <Stack
            id="button-group"
            direction="row"
            style={{paddingTop: 12, paddingLeft: 12}}
          >
            <Button
              style={{ marginRight: '12px' }}
              variant={'text'}
              color={'primary'}
              onClick={handleClickClose}
            >
              {t('common:text.invoice_online_btn_close')}
            </Button>
    
            <Button
              color={'primary'}
              variant={'contained'}
              onClick={handleClickUpdate}
              disabled={!actualitzar}
              className="submit-button"
            >
              {t('common:text.invoice_online_btn_update')}
            </Button>
          </Stack>
          
        </Stack>
      }
    </div>
  );

}

export default ChangeInvoiceOnline;